const user = (state) => state.user

export default {
  user,
}